/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

export const int64CreatedOrUpdatedEntityModelSchema = z.object({
    "id": z.number().int().describe("Идентификатор")
    })